// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".whychoosetefl{padding-bottom:90px!important}.why-icon{padding:4.5%}.padding.whychoosetefl{padding-bottom:30px!important;margin-bottom:20px}.whybox img{width:50%}.half .whybox img,.whybox img{max-width:100px;margin:10px auto}.half .whybox img{width:100%}@media only screen and (max-width:768px){.padding.whychoosetefl{padding-bottom:30px!important;margin-bottom:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
